import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { AuthService } from "../../../services/auth/auth.service";
import { ToastService } from "../../../services/toast/toast.service";
import { ToastTextType } from "../../../shared/object/toast";
import { MetaDataService } from "../../../services/meta/meta-data.service";
import { ImageManager } from "../../../shared/image-manager";
import { AnalyticsService } from "../../../services/analytics/analytics.service";
import { LoginRequest } from "../../../shared/object/xplorer-be-parsed-classes";
import { NgClass } from '@angular/common';

@Component({
    selector: 'xplorer-bowser-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.css'],
    imports: [ReactiveFormsModule, NgClass, TranslateModule]
})
export class LoginPageComponent implements OnInit {
  isShowing = false;
  loginForm: FormGroup;
  source: string = undefined;
  infoMessageKey?: string;

  isFromThirdParty: boolean = navigator.userAgent.includes("Instagram") || navigator.userAgent.includes("facebook") || navigator.userAgent.includes("Linkedin");

  isLoadingUser: boolean = true;
  isLoading: boolean;
  errorTextCode: string;
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private translation = inject(TranslateService);
  private authService = inject(AuthService);
  private toastService = inject(ToastService);
  private metaDataService = inject(MetaDataService);
  private analyticsService = inject(AnalyticsService);

  constructor() {
    this.source = this.router.getCurrentNavigation()?.extras?.state?.['source'];
    this.infoMessageKey = this.router.getCurrentNavigation()?.extras?.state?.['passwordFlowMessage'];
  }

  ngOnInit() {
    this.isLoadingUser = false;
    this.buildForm();
    this.metaDataService.setDefaultMetaData();
  }

  onSubmit() {
    if (this.loginForm.invalid) {
      return;
    }

    this.isLoading = true;

    const { email, password } = this.loginForm.value
    const loginRequest: LoginRequest = {
      password: password,
      email: email
    }

    this.authService.login(loginRequest.email, loginRequest.password)
      .subscribe({
        next: loginResponse => {
          this.authService.applyLoginResponse(loginResponse);
          this.toastService.showSuccessToast(ToastTextType.LOGIN_SUCCESSFUL);
          this.analyticsService.addLoginAction();

          if (this.source) {
            this.router.navigate([this.source])
          } else {
            this.router.navigate(['profile']);
          }
        },
        error: error => {
          this.isLoading = false;
          console.debug("Error code: ", error);
          if (error.status === 401) {
            this.showErrorAlert("login.error.wrong_password")
          } else if (error.status === 404) {
            this.showErrorAlert("login.error.no_account")
          } else {
            this.errorTextCode = 'login.error.text';
          }
        }
      });
  }

  public showErrorAlert(errorTextCode?: string) {
    if (errorTextCode) {
      this.errorTextCode = errorTextCode;
    } else {
      this.errorTextCode = 'login.error.text';
    }
    this.isShowing = true
    setTimeout(() => {
      this.isShowing = false;
    }, 6000);
  }

  keycloakLogin = () => {
    this.authService.googleLogin(this.source);
  }

  getTermOfServiceUrl() {
    const currentLanguage = this.translation.currentLang;
    return 'https://xplorer-platform.com/' + currentLanguage + '/tos/'
  }

  //TODO Maybe dont use form here
  private buildForm() {
    this.loginForm = this.fb.group({
      email: ["", Validators.required],
      password: ["", Validators.required]
    });
  }

  goToRegister() {
    if (this.source) {
      this.router.navigate(['signup'], { state: { source: this.source } });
    } else {
      this.router.navigate(['signup']);
    }
  }

  goToForgotPassword() {
    this.router.navigate(['forgot-password']);
  }

  backToHome() {
    this.router.navigate(['']);
  }

  showPassword: boolean = false;

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }


  protected readonly ImageManager = ImageManager;

}
